import React, { useEffect } from 'react';
import { Button, Form, InputGroup, Modal, Spinner } from '@themesberg/react-bootstrap';
import { ErrorMessage, Formik } from 'formik';
import DateRangePicker from '../DateRangePicker';
import useManageMoney from './hooks/useManageMoney';
import { depositSchema } from './schemas';
import { formatDate } from '../../utils/dateFormatter';
import BonusForm from './BonusForm';

const CasinoBonus = ({ show, handleClose, id, casinoGameBonus }) => {
  const { deposit, state, setState, loading } = useManageMoney({ id, handleClose });

  useEffect(() => {

    if(casinoGameBonus?.bonusExpiryDate && casinoGameBonus?.bonusStartDate){
      setState([
        {
          endDate: new Date(casinoGameBonus?.bonusExpiryDate),
          startDate: new Date(casinoGameBonus?.bonusStartDate),
          key: "selection"
        }
      ])
    } else {
      setState([
        {
          startDate: new Date(),
          endDate: new Date(),
          key: 'selection'
        }
      ])
    }
  }, [casinoGameBonus])

  return (
    <>
      <Formik
        initialValues={{
          bonusAmount: casinoGameBonus,
          startDate: formatDate(state?.[0]?.startDate),
          endDate: formatDate(state?.[0]?.endDate),
        }}
        validationSchema={depositSchema}
        onSubmit={(formValues, { resetForm }) => {
          deposit(formValues);
          // handleClose()
          // resetForm({ formValues: '' })
        }}
      >
        {({ values, touched, errors, handleChange, handleBlur, handleSubmit, resetForm, setFieldValue }) => {
    
          return(
            <BonusForm
              values={values}
              touched={touched}
              errors={errors}
              handleBlur={handleBlur}
              handleChange={handleChange}
              handleSubmit={handleSubmit}
              resetForm={resetForm}
              setFieldValue={setFieldValue}
              casinoGameBonus={casinoGameBonus}
              show={show}
              loading={loading}
              state={state}
              setState={setState}
              handleClose={handleClose}
            />
          )
        }}
      </Formik>
    </>
  );
};

export default CasinoBonus
